import { ReactElement } from 'react';
import { useMedia } from 'react-use';
import { Theme, UiLegacy } from '@silvertours/front-legacy-shared';
import { LocationName, StyledHeader } from './Reviews.styles';

type Props = {
  aggregateRating: number;
  dateLabel: ReactElement;
  locationName?: string;
  ratingLabel: string;
  ratingLocation: string;
};

const ReviewHeader = ({
  aggregateRating,
  dateLabel,
  ratingLabel,
  locationName,
  ratingLocation,
}: Props) => {
  const isMobile = useMedia(
    `(max-width: ${Theme.getBreakpoint('lg')}px)`,
    true,
  );

  return (
    <>
      <StyledHeader>
        <UiLegacy.PlainText>{dateLabel}</UiLegacy.PlainText>
        <UiLegacy.Rating value={aggregateRating} />
        <UiLegacy.SmallText>{ratingLabel}</UiLegacy.SmallText>
        {locationName && !isMobile && (
          <UiLegacy.SmallText>{ratingLocation}</UiLegacy.SmallText>
        )}
      </StyledHeader>
      {locationName && isMobile && (
        <UiLegacy.SmallText>
          <LocationName>{ratingLocation}</LocationName>
        </UiLegacy.SmallText>
      )}
    </>
  );
};
export { ReviewHeader };
